/*
  Clearlight cookie banner and settings dialog (docs/CONSENT.md). The consent state, Consent Mode,
  the dataLayer bridge, the script guard and the Shopify mirror live in the inline stub
  (snippets/cl-consent.liquid, window.clConsent); this file is only the UI.

  Open the settings from anywhere: an element with [data-cl-consent-open], a link to
  #cookie-settings, or clConsent.open().
*/
(function () {
  'use strict';
  var api = window.clConsent;
  var root = document.querySelector('[data-cl-cc]');
  if (!api || !root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var html = document.documentElement;
  var layer = root.querySelector('[data-cl-cc-layer]');
  var dialog = root.querySelector('[data-cl-cc-dialog]');
  var switches = Array.prototype.slice.call(root.querySelectorAll('[data-cl-cc-cat]'));
  var opener = null;
  var primary = root.querySelector('[data-cl-cc-primary]');
  var secondary = root.querySelector('[data-cl-cc-secondary]');
  var dirty = false, busy = false;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function decide(fn) {
    html.classList.remove('cl-cc-ask');
    closeDialog(true);
    fn();
  }
  function accept() { decide(function () { api.acceptAll('accept_all'); }); }
  function reject() {
    // EU: Reject all. UK: "Got it" keeps the default (analytics on, marketing off) and records it.
    if (api.mode === 'uk') decide(function () { api.set({ preferences: true, analytics: true, marketing: false }, 'got_it'); });
    else decide(function () { api.rejectAll('reject_all'); });
  }
  function rejectAll() { decide(function () { api.rejectAll('reject_all'); }); }
  // Drawer "Accept all": switch everything on first, so the visitor sees what they agreed to, then close.
  function acceptAllShown() {
    if (busy) return;
    busy = true;
    switches.forEach(function (s) { s.checked = true; });
    setTimeout(function () { busy = false; accept(); }, calm ? 0 : 260);
  }
  function onCount() { return switches.filter(function (s) { return s.checked; }).length; }
  function labels() {
    if (!primary || !secondary) return;
    if (!dirty) {
      primary.textContent = primary.getAttribute('data-l-all');
      secondary.textContent = secondary.getAttribute('data-l-save');
      return;
    }
    var n = onCount();
    primary.textContent = n ? primary.getAttribute('data-l-n').replace('{n}', n) : primary.getAttribute('data-l-none');
    secondary.textContent = secondary.getAttribute('data-l-all');
  }
  switches.forEach(function (s) { s.addEventListener('change', function () { dirty = true; labels(); }); });
  function save() {
    var c = {};
    switches.forEach(function (s) { c[s.getAttribute('data-cl-cc-cat')] = s.checked; });
    decide(function () { api.set(c, 'save'); });
  }

  function focusables() {
    return Array.prototype.slice.call(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])'))
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeDialog(); return; }
    if (e.key !== 'Tab') return;
    var els = focusables();
    if (!els.length) return;
    var a = els[0], z = els[els.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function openDialog() {
    var s = api.get();
    switches.forEach(function (el) { el.checked = !!s[el.getAttribute('data-cl-cc-cat')]; });
    dirty = false; busy = false; labels();
    opener = document.activeElement;
    layer.hidden = false;
    html.classList.add('cl-cc-dialog-open');
    // next frame so the transition runs from the closed state
    requestAnimationFrame(function () { requestAnimationFrame(function () { layer.classList.add('is-open'); }); });
    document.addEventListener('keydown', onKey);
    setTimeout(function () { var f = dialog.querySelector('[data-cl-cc-close].cl-cc__x'); if (f) f.focus(); }, 60);
  }
  function closeDialog(silent) {
    if (layer.hidden) return;
    layer.classList.remove('is-open');
    html.classList.remove('cl-cc-dialog-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { layer.hidden = true; dialog.style.transform = ''; }, 420);
    if (!silent && opener && opener.focus) { try { opener.focus(); } catch (e) { /* gone */ } }
  }

  // Phones: drag the sheet down by its handle or header to close it.
  (function () {
    var startY = 0, dy = 0, t0 = 0, active = false;
    var sheet = function () { return window.matchMedia('(max-width: 767px)').matches; };
    dialog.addEventListener('pointerdown', function (e) {
      if (!sheet() || !e.target.closest('[data-cl-cc-grab]') || e.target.closest('button')) return;
      active = true; startY = e.clientY; dy = 0; t0 = Date.now();
      dialog.classList.add('is-dragging');
      try { dialog.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
    });
    dialog.addEventListener('pointermove', function (e) {
      if (!active) return;
      dy = Math.max(0, e.clientY - startY);
      dialog.style.transform = 'translateY(' + dy + 'px)';
    });
    function end() {
      if (!active) return;
      active = false;
      dialog.classList.remove('is-dragging');
      var fast = dy > 30 && dy / Math.max(1, Date.now() - t0) > 0.6;
      if (dy > dialog.offsetHeight * 0.25 || fast) { dialog.style.transform = 'translateY(100%)'; closeDialog(); }
      else dialog.style.transform = '';
    }
    dialog.addEventListener('pointerup', end);
    dialog.addEventListener('pointercancel', end);
  })();

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button, [data-cl-cc-close]') : null;
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-cl-cc-primary')) { if (dirty) save(); else acceptAllShown(); }
    else if (t.hasAttribute('data-cl-cc-secondary')) { if (dirty) acceptAllShown(); else save(); }
    else if (t.hasAttribute('data-cl-cc-accept')) accept();
    else if (t.hasAttribute('data-cl-cc-reject')) reject();
    else if (t.hasAttribute('data-cl-cc-rejectall')) rejectAll();
    else if (t.hasAttribute('data-cl-cc-save')) save();
    else if (t.hasAttribute('data-cl-cc-custom')) openDialog();
    else if (t.hasAttribute('data-cl-cc-close')) closeDialog();
  });

  // Footer link, policy pages, anything else that asks for the settings.
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cl-consent-open], a[href$="#cookie-settings"], a[href$="#cookie-einstellungen"]') : null;
    if (!t) return;
    e.preventDefault();
    openDialog();
  });
  document.addEventListener('cl:consent-open', openDialog);
  if (/^#cookie-(settings|einstellungen)$/.test(location.hash)) openDialog();

  html.classList.add('cl-cc-ready');
})();
